import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

import { Box, Divider } from "../../../../../mads";
import { useViewjobProctorAllocation } from "../../../../proctor/__generated__/ViewjobProctorContext";
import { MobVjJobSummaryTst } from "../../../../proctor/__generated__/ViewjobProctorSpecifications";
import { useFullScreenVJActive } from "../../../hooks/useFullScreenVJActive";

export interface ViewJobDividerProps {
  readonly sx?: React.ComponentProps<typeof Divider>["sx"];
}

/**
 * ViewJob-specific divider that wraps MADS Divider with -16 horizontal margin
 * to maintain consistent spacing behavior that was previously provided by IFL Divider.
 *
 * When the mob_vj_job_summary_tst proctor test is active, renders a thicker divider
 * with a different background color to test the new job summary design.
 */
export function ViewJobDivider(props: ViewJobDividerProps): React.JSX.Element {
  const isJobSummaryTestActive = useViewjobProctorAllocation(MobVjJobSummaryTst).value > 0;

  const isFullScreenVJActive = useFullScreenVJActive();

  if (isFullScreenVJActive) {
    return (
      <Box sx={styles.fullScreenVJDividerContainer}>
        <Divider sx={props.sx} />
      </Box>
    );
  }

  if (isJobSummaryTestActive) {
    return (
      <Box sx={styles.dividerContainer}>
        <Box sx={[styles.testDividerWrapper, props.sx]} />
      </Box>
    );
  }

  return (
    <Box sx={styles.dividerContainer}>
      <Divider sx={props.sx} />
    </Box>
  );
}

const styles = StyleSheet.create({
  dividerContainer: {
    marginStart: -16,
    marginEnd: -16,
  },
  fullScreenVJDividerContainer: {
    marginStart: 0,
    marginEnd: 0,
  },
  testDividerWrapper: {
    height: 8,
    backgroundColor: colors.backgroundWeaker,
  },
});
